import { Controller } from "@hotwired/stimulus"

// Strips non-numeric characters from input fields before submission.
//
// Usage:
//   <input data-controller="numeric-input"
//          data-numeric-input-type-value="integer" />
//
//   <input data-controller="numeric-input"
//          data-numeric-input-type-value="decimal" />
//
// Types:
//   "integer" — digits only (e.g. mileage: "69,420" → "69420")
//   "decimal" — digits and one decimal point (e.g. price: "$32,500.00" → "32500.00")
//
export default class extends Controller {
  static values = {
    type: { type: String, default: "integer" }
  }

  strip() {
    if (this.typeValue === "decimal") {
      this.element.value = this.stripDecimal(this.element.value)
    } else {
      this.element.value = this.stripInteger(this.element.value)
    }
  }

  stripInteger(value) {
    return value.replace(/[^0-9]/g, "")
  }

  stripDecimal(value) {
    // Remove everything except digits and dots
    let cleaned = value.replace(/[^0-9.]/g, "")

    // Keep only the first decimal point
    const parts = cleaned.split(".")
    if (parts.length > 2) {
      cleaned = parts[0] + "." + parts.slice(1).join("")
    }

    return cleaned
  }
}
